import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-100 text-foreground-50 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Column 1 - Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img
                alt="The Screen Squad — Screen Repair Service"
                className="h-14 w-auto object-contain"
                src="https://static.readdy.ai/image/e2264d4847cbc98dfbe6fd1d0e6b7ca4/c480cc975a256a5055b1791bd11fefde.png"
              />
            </div>
            <p className="text-foreground-400 text-sm leading-relaxed mt-4">
              {t('footer.description')}
            </p>
            <iframe
              title={t('contactPage.mapTitle')}
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d106364.5!2d-117.9143!3d33.7455!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80dcd6f980c0cb0f%3A0x8b5e5c6e7d8e9f0a!2sSanta%20Ana%2C%20CA!5e0!3m2!1ses!2sus!4v1699999999999!5m2!1ses!2sus"
              width="100%"
              height="140"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="rounded-lg mt-5"
            />
          </div>

          {/* Column 2 - Navigation */}
          <div>
            <h4 className="text-primary-500 font-semibold uppercase text-xs tracking-widest mb-5">
              {t('footer.navTitle')}
            </h4>
            <ul className="flex flex-col gap-3">
              <li>
                <Link to="/" className="text-foreground-400 text-sm hover:text-primary-500 transition-colors cursor-pointer">
                  {t('footer.nav.home')}
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-foreground-400 text-sm hover:text-primary-500 transition-colors cursor-pointer">
                  {t('footer.nav.services')}
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-400 text-sm hover:text-primary-500 transition-colors cursor-pointer">
                  {t('footer.nav.about')}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-foreground-400 text-sm hover:text-primary-500 transition-colors cursor-pointer">
                  {t('footer.nav.contact')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3 - Services */}
          <div>
            <h4 className="text-primary-500 font-semibold uppercase text-xs tracking-widest mb-5">
              {t('footer.servicesTitle')}
            </h4>
            <ul className="flex flex-col gap-3">
              <li>
                <Link to="/services" className="text-foreground-400 text-sm hover:text-primary-500 transition-colors cursor-pointer">
                  {t('footer.services.sprayFoam')}
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-foreground-400 text-sm hover:text-primary-500 transition-colors cursor-pointer">
                  {t('footer.services.batt')}
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-foreground-400 text-sm hover:text-primary-500 transition-colors cursor-pointer">
                  {t('footer.services.cellulose')}
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-foreground-400 text-sm hover:text-primary-500 transition-colors cursor-pointer">
                  {t('footer.services.attic')}
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-foreground-400 text-sm hover:text-primary-500 transition-colors cursor-pointer">
                  {t('footer.services.wall')}
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-foreground-400 text-sm hover:text-primary-500 transition-colors cursor-pointer">
                  {t('footer.services.crawlSpace')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4 - Contact */}
          <div>
            <h4 className="text-primary-500 font-semibold uppercase text-xs tracking-widest mb-5">
              {t('footer.contactTitle')}
            </h4>
            <ul className="flex flex-col gap-4">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-primary-500 w-5 h-5 flex items-center justify-center" />
                </div>
                <span className="text-foreground-400 text-sm leading-relaxed whitespace-pre-line">
                  {t('footer.address')}
                </span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-phone-line text-primary-500 w-5 h-5 flex items-center justify-center" />
                </div>
                <div className="flex flex-col gap-1">
                  <a
                    href="tel:+16574338533"
                    className="text-foreground-400 text-sm hover:text-primary-500 transition-colors cursor-pointer block"
                  >
                    {t('footer.phone')}
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-mail-line text-primary-500 w-5 h-5 flex items-center justify-center" />
                </div>
                <a
                  href="mailto:thescreensquadcrew@gmail.com"
                  className="text-foreground-400 text-sm hover:text-primary-500 transition-colors cursor-pointer block"
                >
                  {t('footer.email')}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-time-line text-primary-500 w-5 h-5 flex items-center justify-center" />
                </div>
                <div className="flex flex-col gap-1">
                  <span className="text-foreground-50 text-sm font-semibold">
                    {t('footer.hoursTitle')}
                  </span>
                  <span className="text-foreground-400 text-sm">
                    {t('footer.hoursWeekday')}
                  </span>
                  <span className="text-foreground-400 text-sm">
                    {t('footer.hoursWeekend')}
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-400/50 text-xs font-medium">
            {t('footer.copyright')}
          </p>
          <div className="flex items-center gap-3">
            <p className="text-foreground-400/50 text-xs font-medium">
              {t('footer.serving')}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}